import React, { useRef } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { BigButton } from '../../../../../../../client/components/button/index';
import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import { useCallback } from "react";
import _ from "lodash";
import { trim } from 'lodash';
import Alert from '../../../../../../../client/components/alert/index';
import { fetchSaveComments } from "../../../../../../../api";


const ReviewSubmit = props =>{
    useStyles(cls);
    const { sizeInfomation, commentsList, orderDetail, sizeChange, setTemplateStr } = props;
    const [loading, setLoading] = useState(false);
    const Intl = useIntl();
    const firstRef = useRef(false);

    const validNumber = useCallback((number) =>{
        return !!number && Number(number) > 0;
    }, []);

    const getErrorMsg = useCallback((comment) =>{
        let erorMsg;
        if(!trim(comment?.content)){
            erorMsg = `${Intl.formatMessage({ id: "comments", defaultMessage: "Comments" })}`;
        } else if(!(comment?.score > 0)){
            erorMsg = `${Intl.formatMessage({ id: "rating", defaultMessage: "Rating" })}`;
        }else if(!validNumber(comment?.sizingRecommendation)){
            erorMsg = `${Intl.formatMessage({ id: "overall_fit", defaultMessage: "Overall Fit" })}`;
        }
        return erorMsg;
    }, []);

    const handleSubmit = useCallback(async () =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: 'Save Review',
                orderId: orderDetail?.id
            })
        }

        setLoading(true);
        let comments = [];
        let flag = false;
        commentsList?.forEach(comment =>{
            let initData = {
                id: comment?.id,
                productId: comment?.productId,
                orderId: orderDetail?.id,
                varaintId: comment?.varaintId || comment?.variantId,
            };

            if(!!trim(comment?.content) && comment?.score > 0 && validNumber(comment?.sizingRecommendation)){
                initData['content'] = comment.content;
                initData['score'] = comment.score;
                initData['sizingRecommendation'] = comment.sizingRecommendation;
                flag = true;
            }

            if(comment?.images.length > 0){
                initData['images'] = comment.images;
            }

            comments.push(initData);
        });


        if(!flag){
            let commentValid = commentsList?.find((comment)=>{
                return !!trim(comment?.content) || comment?.score > 0 || validNumber(comment?.sizingRecommendation);
            })
            let errorMsg = getErrorMsg(commentValid || commentsList?.[0]);
            Alert(`${errorMsg} ${Intl.formatMessage({ id: "not_be_empty", defaultMessage: "can not be empty!" })}`);
            setLoading(false);
            firstRef.current = false;
            return;
        }
        
        let params = {comments};
        let sizeFlag = Object.keys(sizeInfomation).some(key => !!sizeInfomation[key]);
        if(sizeChange && sizeFlag){
            params['mySizeInformation'] = sizeInfomation;
        }
        let response = await fetchSaveComments(params);
        setTemplateStr(response?.prompt?.html);
        setLoading(false);
    }, [sizeInfomation, commentsList, orderDetail, sizeChange]);

    return <React.Fragment>
        <div className={cls.ReviewSubmit}>
            <div className={cls.Container}>
                <BigButton loading={loading} onClick={handleSubmit}><FormattedMessage id="success" defaultMessage="Success" /></BigButton>
            </div>
        </div>

        <div className={cls.FixedItem}></div>
    </React.Fragment>
}

export default ReviewSubmit;